import React, { useEffect, useState, useCallback, useRef } from "react";
import { graphqlPost } from "../../api/_call";
import { useTranslation } from 'react-i18next';
// import SelectSearch from "react-select-search";
// import 'react-select-search/style.css'
import Select, { components } from "react-select";

const base_assets = process.env.REACT_APP_BASE_ASSETS_URL

const { ValueContainer, Placeholder } = components;
const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};
export const LocationList1 = (props) => {
  const { t } = useTranslation();

  const { setcommanSelected_loc, locationid, addclass, hidelocationid, setpo } = props;
  const [LocationList, setLocationList] = useState();
  const [LocationarrayList, setLocationarrayList] = useState([]);
  const getLocationList = useCallback(async () => {
    try {
      const postData = `{
        locations {
          id
          name  
          type         
        }
      }`;
      const response = await graphqlPost(postData);
      let locationArray = [];
      if (response.data?.locations) {
        const filteredLocations = hidelocationid
          ? response.data.locations.filter(item => item?.id !== hidelocationid)
          : response.data.locations;

        locationArray = filteredLocations.map(({ id, name, type }) => ({
          value: id,
          label: name,
          icon: <img src={base_assets + "images/admin/icons/" + type?.toLowerCase() + "-icon.png"} alt="" />,
        }));
      }
      setLocationarrayList(locationArray);
      if (locationid) {
        const selected = locationArray.filter(option => option.value === locationid);
        setLocationList({ label: selected[0]?.label, value: locationid });
        setcommanSelected_loc(locationid);
      }
    } catch (err) {
      console.error(err, "err");
    }
    // eslint-disable-next-line
  }, [locationid]);

  useEffect(() => {
    if (locationid) {
      getLocationList();
    } else {
      getLocationList();
    }
    // eslint-disable-next-line
  }, [locationid]);


  return (
    <React.Fragment>
      <div className={locationid !== 'null' ? addclass ? "placeholder-up-input row-inactive" : "placeholder-up-input" : 'placeholder-up-input'} >
        <Select
          className=" select-set select p-0 z-10"
          placeholder={t("Ship to")}
          options={LocationarrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={LocationList}

          onChange={setpo ? (e) => { setLocationList(e); setcommanSelected_loc(e?.value) } :
            (e) => { setLocationList(e); setcommanSelected_loc(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(e) => (
            <div className="common-select-icon">{e.icon}
              <span>{e.label}</span></div>
          )}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};


export const LocationList = (props) => {
  const { t } = useTranslation();

  const {
    setcommanSelected_loc,
    locationid,
    locationname,
    addclass,
    hidelocationid,
    setpo,
    commanSelected_vouc,
    // setLocationType
  } = props;

  const [LocationList, setLocationList] = useState();
  const [LocationarrayList, setLocationarrayList] = useState([]);

  const getLocationList = useCallback(async () => {
    try {
      // Original behavior for all screens: require voucher before loading locations.
      // locationname is optional and only passed by PO Excel import (createpoReplenishOrder).
      if (!commanSelected_vouc || commanSelected_vouc === 'null') {
        if (locationid && locationname) {
          setLocationList({ label: locationname, value: locationid });
          setcommanSelected_loc(locationid);
        }
        return;
      }

      const postData = `{
        voucherById(id: "${commanSelected_vouc}") {
           id
          name
          locations{
              id,
              name,
              type
          }
        }
      }`;

      const response = await graphqlPost(postData);
      let locationArray = [];

      const locations = response?.data?.voucherById?.locations || [];

      const filteredLocations = hidelocationid
        ? locations.filter(item => item?.id !== hidelocationid)
        : locations;

      locationArray = filteredLocations.map(({ id, name, type }) => ({
        value: id,
        label: name,
        type:type,
        icon: (
          <img
            src={`${base_assets}images/admin/icons/${type?.toLowerCase()}-icon.png`}
            alt=""
          />
        )
      }));

      setLocationarrayList(locationArray);

      if (locationid) {
        const selected = locationArray.find(option => String(option.value) === String(locationid));
        if (selected) {
          setLocationList({ label: selected.label, value: selected.value });
          setcommanSelected_loc(selected.value);
          // setLocationType(selected?.type)
        } else if (locationname) {
          // Opt-in only (PO import / edit with location_name): same location name
          // can have a different id than voucher location — match by name on voucher list.
          const byName = locationArray.find(
            (option) =>
              String(option.label || "").toLowerCase() ===
              String(locationname).trim().toLowerCase()
          );
          if (byName) {
            setLocationList({ label: byName.label, value: byName.value });
            setcommanSelected_loc(byName.value);
          } else {
            setLocationList({ label: locationname, value: locationid });
            setcommanSelected_loc(locationid);
          }
        }
      }
    } catch (err) {
      console.error("Error loading locations:", err);
    }
  }, [locationid, locationname, commanSelected_vouc, hidelocationid, setcommanSelected_loc]);

  useEffect(() => {
    getLocationList();
  }, [locationid, locationname, commanSelected_vouc]);

  return (
    <React.Fragment>
      <div
        className={
          locationid !== 'null'
            ? addclass
              ? "placeholder-up-input row-inactive"
              : "placeholder-up-input"
            : "placeholder-up-input"
        }
      >
        <Select
          className="select-set select p-0"
          placeholder={t("Ship to")}
          options={LocationarrayList}
          components={{ ValueContainer: CustomValueContainer }}
          value={LocationList}
          onChange={e => {
            setLocationList(e);
            setcommanSelected_loc(e?.value);
            // setLocationType(e?.type)
          }}
          classNamePrefix="common-select"
          getOptionLabel={e => (
            <div className="common-select-icon">
              {e.icon}
              <span>{e.label}</span>
            </div>
          )}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

export const ZoneLocation = (props) => {
  const { setcommanSelected_loc, locationid, addclass, hidelocationid, setpo } = props;
  const [LocationList, setLocationList] = useState();
  const [LocationarrayList, setLocationarrayList] = useState([]);
  const getLocationList = useCallback(async () => {
    try {
      const postData = `{
        locations {
          id
          name  
          type         
        }
      }`;
      const response = await graphqlPost(postData);
      let locationArray = [];
      if (response.data?.locations) {
        const filteredLocations = hidelocationid
          ? response.data.locations.filter(item => item?.id !== hidelocationid)
          : response.data.locations;

        locationArray = filteredLocations.map(({ id, name, type }) => ({
          value: id,
          label: name,
          icon: <img src={base_assets + "images/admin/icons/" + type?.toLowerCase() + "-icon.png"} alt="" />,
        }));
      }
      setLocationarrayList(locationArray);
      if (locationid) {
        const selected = locationArray.filter(option => option.value === locationid);
        setLocationList({ label: selected[0]?.label, value: locationid });
        setcommanSelected_loc(locationid);
      }
    } catch (err) {
      console.error(err, "err");
    }
    // eslint-disable-next-line
  }, [locationid]);

  useEffect(() => {
    if (locationid) {
      getLocationList();
    } else {
      getLocationList();
    }
    // eslint-disable-next-line
  }, [locationid]);


  return (
    <React.Fragment>
      <div className={locationid !== 'null' ? addclass ? "placeholder-up-input row-inactive" : "placeholder-up-input" : 'placeholder-up-input'} >
        <Select
          className=" select-set select p-0 z-10"
          placeholder={`Select Location`}
          options={LocationarrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={LocationList}

          onChange={setpo ? (e) => { setLocationList(e); setcommanSelected_loc(e?.value) } :
            (e) => { setLocationList(e); setcommanSelected_loc(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(e) => (
            <div className="common-select-icon">{e.icon}
              <span>{e.label}</span></div>
          )}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

export const ZoneList = (props) => {

  const { setcommanSelected_loc, locationid, addclass, hidelocationid, setpo } = props;
  const [LocationList, setLocationList] = useState();
  const [LocationarrayList, setLocationarrayList] = useState([]);
  const getLocationList = useCallback(async () => {
    try {
      const postData = `{
        locations {
          id
          name  
          type         
        }
      }`;
      const response = await graphqlPost(postData);
      let locationArray = [];
      if (response.data?.locations) {
        const filteredLocations = hidelocationid
          ? response.data.locations.filter(item => item?.id !== hidelocationid)
          : response.data.locations;

        locationArray = filteredLocations.map(({ id, name, type }) => ({
          value: id,
          label: name,
          icon: <img src={base_assets + "images/admin/icons/" + type?.toLowerCase() + "-icon.png"} alt="" />,
        }));
      }
      setLocationarrayList(locationArray);
      if (locationid) {
        const selected = locationArray.filter(option => option.value === locationid);
        setLocationList({ label: selected[0]?.label, value: locationid });
        setcommanSelected_loc(locationid);
      }
    } catch (err) {
      console.error(err, "err");
    }
    // eslint-disable-next-line
  }, [locationid]);

  useEffect(() => {
    if (locationid) {
      getLocationList();
    } else {
      getLocationList();
    }
    // eslint-disable-next-line
  }, [locationid]);


  return (
    <React.Fragment>
      <div className={locationid !== 'null' ? addclass ? "placeholder-up-input row-inactive" : "placeholder-up-input" : 'placeholder-up-input'} >
        <Select
          className=" select-set select p-0 z-10"
          placeholder={`Select Zone`}
          options={LocationarrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={LocationList}

          onChange={setpo ? (e) => { setLocationList(e); setcommanSelected_loc(e?.value) } :
            (e) => { setLocationList(e); setcommanSelected_loc(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(e) => (
            <div className="common-select-icon">{e.icon}
              <span>{e.label}</span></div>
          )}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

export const SupplierList = (props) => {
  const { t } = useTranslation();
  const dataFetched = useRef();
  const [SupplierList, setSupplierList] = useState();
  const [SupplierListarray, setSupplierListarray] = useState([]);
  // suppliername is optional — only createpoReplenishOrder PO Excel import passes it.
  const { setcommanSelected_sup, supplierid, suppliername, addclass } = props;
  const getSupplierList = useCallback(async () => {
    try {
      const postdata = `{
        suppliers {
          id
          name 
          organization
        }
      }`;
      let responce = await graphqlPost(postdata);
      let supplierarray = [];
      if (responce.data?.suppliers) {
        responce.data?.suppliers?.map((result) => {
          return (
            supplierarray.push(
              {
                value: result?.id,
                label: result?.organization
              }
            )
          )
        });
      }
      setSupplierListarray(supplierarray);
      if (supplierid) {
        const selected = supplierarray.filter(option => option.value === supplierid);
        const label = selected[0]?.label || suppliername || "";
        setSupplierList({ label, value: supplierid });
        setcommanSelected_sup(supplierid);
      }
    } catch (err) {
      console.error(err, "err");
    }
  }, [supplierid, suppliername, setSupplierListarray, setcommanSelected_sup]);

  useEffect(() => {
    if (supplierid) {
      getSupplierList();
    } else {
      if (dataFetched.current) return;
      dataFetched.current = true;
      getSupplierList();
    }
  }, [getSupplierList, supplierid]);


  return (
    <React.Fragment>
      <div className={addclass ? "placeholder-up-input row-inactive" : "placeholder-up-input"}>
        <Select
          className=" select-set select  p-0"
          placeholder={t("Supplier")}
          options={SupplierListarray}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={SupplierList}
          onChange={(e) => { setSupplierList(e); setcommanSelected_sup(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(opt) => opt.label}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

export const VoucherList = (props) => {
  const [VoucherList, setVoucherList] = useState([]);
  const [voucher_name, setVoucher_name] = useState();
  const dataFetched = useRef();
  const { setcommanSelected_vouc, group, voucherid, addclass } = props;
  // const [voucher_id, setVoucher_id] = useState(voucherid);
  const getVoucherList = useCallback(async () => {
    try {
      const postdata = `{
        vouchers(group: "`+ group + `") {
          id
          name 
      }
        }`;
      let responce = await graphqlPost(postdata);
      var data_arr = [];
      responce.data.vouchers.forEach((result) => {
        var id = responce.data.vouchers[0].id ? responce.data.vouchers[0].id : '';
        if (id) {
          setcommanSelected_vouc(id);
        }
        setVoucher_name(responce.data.vouchers[0].name)
        data_arr.push({ 'label': result.name, 'value': result.id });
      })
      setVoucherList(data_arr);
    } catch (err) {
      console.log(err, "err");
    }
  }, [setcommanSelected_vouc, group]);
  const [selectedVoucher, setSelectedVoucher] = useState(VoucherList[0]);
  const selectVoucher = (input) => {
    console.log(input, "input", input?.value);

    setcommanSelected_vouc(input?.value);
    setSelectedVoucher(input);
  }
  useEffect(() => {
    if (voucherid) {
      getVoucherList();
    } else {
      if (dataFetched.current) return;
      dataFetched.current = true;
      getVoucherList();
    }
  }, [getVoucherList, voucherid]);
  useEffect(() => {
    // setVoucher_id(voucherid);
  }, [voucherid]);

  return (
    <React.Fragment>
      <Select
        className={addclass ? "dmc-switch  dark-style row-inactive" : "dmc-switch  dark-style"}
        classNamePrefix="voucher-list common-select"
        options={VoucherList}
        onChange={selectVoucher}
        value={selectedVoucher ? selectedVoucher : VoucherList[0]}
        name="language"
        placeholder={voucher_name ? voucher_name : 'no voucher'}
      />

    </React.Fragment>
  );
};

export const Saleperson = (props) => {
  const { t } = useTranslation();
  const dataFetched = useRef();
  const [SalesList, setSalesList] = useState();
  const [SalesarrayList, setSalesarrayList] = useState([]);
  const { setcommanSelected_sal } = props;
  const getSalesList = useCallback(async () => {
    try {
      const postdata = `{
          salespersons {
              id
              name 
          }
        }`;

      let responce = await graphqlPost(postdata);
      let Salesarray = [];
      if (responce.data?.salespersons) {
        responce.data?.salespersons?.forEach((result) => {
          Salesarray.push(
            {
              value: result?.id,
              label: result?.name

            }
          );
        })
      };
      setSalesarrayList(Salesarray);
    } catch (err) {
      console.log(err, "err");
    }
  }, [setSalesarrayList]);
  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    getSalesList();
  }, [getSalesList]);

  return (
    <React.Fragment>
      <div className="placeholder-up-input">
        <Select
          className=" select-set select  p-0"
          placeholder={t("Saleperson")}
          options={SalesarrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={SalesList}
          onChange={(e) => { setSalesList(e); setcommanSelected_sal(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(opt) => opt.label}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};


export const WarehouseList = (props) => {
  const { t } = useTranslation();
  const dataFetched = useRef();
  const { setcommanSelected_warehouse, warehouseid } = props;
  const [warehouseList, setwarehouseList] = useState();
  const [warehousearrayList, setwarehousearrayList] = useState([]);
  const getLocationList = useCallback(async () => {
    try {
      const postdata = `{
            locations (type: "Warehouse") {
                id
                name 
            }
        }`;
      let responce = await graphqlPost(postdata);
      let warehousearray = [];
      if (responce.data?.locations) {
        responce.data?.locations?.forEach((result) => {
          warehousearray.push(
            {
              value: result?.id,
              label: result?.name
            }
          );
        })
      };
      setwarehousearrayList(warehousearray);
      if (warehouseid) {
        const selected = warehousearray.filter(option => option.value === warehouseid);
        setwarehouseList({ label: selected[0].label, value: warehouseid });
        setcommanSelected_warehouse(warehouseid);
      }

    } catch (err) {
      console.log(err, "err");
    }
  }, [setwarehouseList, setcommanSelected_warehouse, warehouseid]);
  useEffect(() => {
    if (warehouseid) {
      getLocationList();
    } else {
      if (dataFetched.current) return;
      dataFetched.current = true;
      getLocationList();
    }
  }, [warehouseid, getLocationList]);

  return (
    <React.Fragment>
      <div className="placeholder-up-input red-highlight-select">
        <Select
          className=" select-set select  p-0"
          placeholder={t("Warehouse")}
          options={warehousearrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={warehouseList}
          onChange={(e) => { setwarehouseList(e); setcommanSelected_warehouse(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(opt) => opt.label}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

export const StoresList = (props) => {
  const dataFetched = useRef();
  const { setcommanSelected_warehouse, warehouseid } = props;
  const [warehouseList, setwarehouseList] = useState();
  const [warehousearrayList, setwarehousearrayList] = useState([]);
  const getLocationList = useCallback(async () => {
    try {
      const postdata = `{
            locations (type: "Store") {
                id
                name 
            }
        }`;
      let responce = await graphqlPost(postdata);
      let warehousearray = [];
      if (responce.data?.locations) {
        responce.data?.locations?.forEach((result) => {
          warehousearray.push(
            {
              value: result?.id,
              label: result?.name

            }
          );
        })
      };
      setwarehousearrayList(warehousearray);
      if (warehouseid) {
        const selected = warehousearray.filter(option => option.value === warehouseid);
        setwarehouseList({ label: selected[0].label, value: warehouseid });
        setcommanSelected_warehouse(warehouseid);
      }

    } catch (err) {
      console.log(err, "err");
    }
  }, [setwarehouseList, setcommanSelected_warehouse, warehouseid]);


  useEffect(() => {
    if (warehouseid) {
      getLocationList();
    } else {
      if (dataFetched.current) return;
      dataFetched.current = true;
      getLocationList();
    }
  }, [warehouseid, getLocationList]);

  return (
    <React.Fragment>
      <div className="placeholder-up-input">
        <Select
          className=" select-set select  p-0"
          placeholder="Locations"
          options={warehousearrayList}
          components={{
            ValueContainer: CustomValueContainer,
          }}
          value={warehouseList}
          onChange={(e) => { setwarehouseList(e); setcommanSelected_warehouse(e?.value) }}
          classNamePrefix="common-select"
          getOptionLabel={(opt) => opt.label}
          isSearchable={false}
        />
      </div>
    </React.Fragment>
  );
};

// export const MultiLocationList = (props) => {
//   const dataFetched = useRef();
//   const { setMultisetcommanSelected_loc } = props;
//   const [MultiLocationList, setMultiLocationList] = useState();
//   const [multiLocationarrayList, setMultiLocationarrayList] = useState([]);
//   const getLocationList = async () => {
//     try {
//       const postdata = `{
//             locations {
//                 id
//                 name 
//             }
//         }`;
//       let responce = await graphqlPost(postdata);
//       let multilocationarray = [];
//       if (responce.data?.locations) {
//         responce.data?.locations?.forEach((result) => {
//           multilocationarray.push(
//             {
//               value: result?.id,
//               label: result?.name

//             }
//           );
//         })
//       };
//       setMultiLocationarrayList(multilocationarray);
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   useEffect(() => {
//     if (dataFetched.current) return;
//     dataFetched.current = true;
//     getLocationList();
//   }, []);
//   return (
//     <React.Fragment>

//       <Select
//         placeholder="Select Store"
//         options={multiLocationarrayList}
//         value={MultiLocationList}
//         onChange={(e) => { setMultiLocationList(e); setMultisetcommanSelected_loc(e) }}
//         classNamePrefix="product-multi-select"
//         getOptionLabel={(e) => (
//           <div className="product-multi-select__multi-value__label-ct">
//             <span>{e.label}</span>
//           </div>
//         )}
//         isSearchable={false}
//         isMulti={true}
//       />
//     </React.Fragment>
//   );
// }


export const MultiLocationList = ({ setMultisetcommanSelected_loc }) => {
  const dataFetched = useRef(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);

  const SELECT_ALL_VALUE = "*";

  const getLocationList = async () => {
    try {
      const postdata = `{
        locations {
          id
          name 
        }
      }`;

      const response = await graphqlPost(postdata);
      let options = [];

      if (response.data?.locations) {
        options = response.data.locations.map((location) => ({
          value: location.id,
          label: location.name,
        }));
      }

      // Add "Select All" option at the top
      const selectAllOption = {
        value: SELECT_ALL_VALUE,
        label: "Select All",
      };

      setLocationOptions([selectAllOption, ...options]);
    } catch (err) {
      console.error("Failed to fetch locations", err);
    }
  };

  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    getLocationList();
  }, []);

  const handleChange = (selected) => {
    const isSelectAllSelected = selected?.some(
      (opt) => opt.value === SELECT_ALL_VALUE
    );

    if (isSelectAllSelected) {
      const allOptionsExceptSelectAll = locationOptions.filter(
        (opt) => opt.value !== SELECT_ALL_VALUE
      );
      setSelectedLocations(allOptionsExceptSelectAll);
      setMultisetcommanSelected_loc(allOptionsExceptSelectAll);
    } else {
      setSelectedLocations(selected);
      setMultisetcommanSelected_loc(selected);
    }
  };

  // Optional: improve filtering for "Select All"
  const customFilterOption = (option, searchText) => {
    return option.label.toLowerCase().includes(searchText.toLowerCase());
  };

  return (
    <Select
      placeholder="Select Store"
      options={locationOptions}
      value={selectedLocations}
      onChange={handleChange}
      classNamePrefix="product-multi-select"
      isSearchable={true}
      isMulti={true}
      filterOption={customFilterOption}
      formatOptionLabel={(e) => (
        <div className="product-multi-select__multi-value__label-ct">
          <span>{e.label}</span>
        </div>
      )}
    />
  );
};

export const MultiSalePersons = (props) => {
  const dataFetched = useRef();
  const { setMultisetcommanSelected_loc } = props;
  const [MultiLocationList, setMultiLocationList] = useState();
  const [multiLocationarrayList, setMultiLocationarrayList] = useState([]);
  const getLocationList = async () => {
    try {
      const postdata = `{
            locations {
                id
                name 
            }
        }`;
      let responce = await graphqlPost(postdata);
      let multilocationarray = [];
      if (responce.data?.locations) {
        responce.data?.locations?.forEach((result) => {
          multilocationarray.push(
            {
              value: result?.id,
              label: result?.name

            }
          );
        })
      };
      setMultiLocationarrayList(multilocationarray);
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    getLocationList();
  }, []);
  return (
    <React.Fragment>
      <Select
        placeholder={`Sale Person`}
        className="w-100"
        options={multiLocationarrayList}
        components={{
          ValueContainer: CustomValueContainer,
        }}
        value={MultiLocationList}
        onChange={(e) => { setMultiLocationList(e); setMultisetcommanSelected_loc(e) }}
        classNamePrefix="common-select"
        getOptionLabel={(e) => (
          <div className="product-multi-select__multi-value__label-ct">
            <span>{e.label}</span>
          </div>
        )}
        isSearchable={false}
        isMulti={true}
      />

    </React.Fragment>
  );
}





